(function () {
  function hideSearch() {
    const content = document.querySelector('.rptn-order-tracking-content');
    const searches = document.querySelectorAll('.rptn-order-tracking-search');
    if (!content || !searches.length) return;

    const hasResult = content.getBoundingClientRect().height > 250;

    searches.forEach((box) => {
      if (hasResult) {
        box.style.setProperty('display', 'none', 'important');
      } else {
        box.style.removeProperty('display');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    hideSearch();
    setInterval(hideSearch, 300);
  });
})();